var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 78,
    viewBox: "0 0 63 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1483 76.2232H3.99054C3.72914 76.2232 3.47032 76.1718 3.22881 76.0717C2.98731 75.9716 2.76787 75.825 2.58303 75.6402C2.3982 75.4553 2.25157 75.236 2.15153 74.9944C2.0515 74.7529 2.00002 74.4941 2.00002 74.2327V11.6743C1.99894 11.4122 2.04963 11.1525 2.14918 10.91C2.24874 10.6676 2.39518 10.4472 2.58013 10.2615C2.76508 10.0758 2.98488 9.92841 3.22691 9.82782C3.46896 9.72731 3.72845 9.67554 3.99054 9.67554H52.0992C52.6452 9.67554 53.169 9.89187 53.5559 10.2773C53.9428 10.6626 54.1613 11.1856 54.1634 11.7316V74.2163C54.1656 74.4812 54.1149 74.7438 54.0143 74.9888C53.9137 75.2338 53.7653 75.4563 53.5776 75.6432C53.39 75.8301 53.1668 75.9777 52.9214 76.0773C52.676 76.1769 52.4131 76.2265 52.1483 76.2232Z",
    fill: "#E3FFE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1483 76.2232H3.99054C3.72914 76.2232 3.47032 76.1718 3.22881 76.0717C2.98731 75.9716 2.76787 75.825 2.58303 75.6402C2.3982 75.4553 2.25157 75.236 2.15153 74.9944C2.0515 74.7529 2.00002 74.4941 2.00002 74.2327V11.6743C1.99894 11.4122 2.04963 11.1525 2.14918 10.91C2.24874 10.6676 2.39518 10.4472 2.58013 10.2615C2.76508 10.0758 2.98488 9.92841 3.22691 9.82782C3.46896 9.72731 3.72845 9.67554 3.99054 9.67554H52.0992C52.6452 9.67554 53.169 9.89187 53.5559 10.2773C53.9428 10.6626 54.1613 11.1856 54.1634 11.7316V74.2163C54.1656 74.4812 54.1149 74.7438 54.0143 74.9888C53.9137 75.2338 53.7653 75.4563 53.5776 75.6432C53.39 75.8301 53.1668 75.9777 52.9214 76.0773C52.676 76.1769 52.4131 76.2265 52.1483 76.2232Z",
    stroke: "#00BC66",
    strokeWidth: 2.04787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50342 4.01511V66.508C9.50342 67.041 9.71459 67.5523 10.0907 67.9299C10.4668 68.3077 10.9773 68.5209 11.5103 68.5231H59.6434C60.1779 68.5231 60.6905 68.3108 61.0683 67.9329C61.4463 67.5549 61.6585 67.0424 61.6585 66.508V18.6369H47.0368C46.7694 18.6369 46.5046 18.5838 46.258 18.4805C46.0113 18.3772 45.7877 18.2258 45.6002 18.0352C45.4126 17.8446 45.2648 17.6185 45.1656 17.3703C45.0663 17.122 45.0173 16.8564 45.0216 16.589V2H11.5103C10.9773 2.00217 10.4668 2.21543 10.0907 2.5931C9.71459 2.97077 9.50342 3.48209 9.50342 4.01511Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2588 5.12109V19.7675C46.2577 20.0327 46.3091 20.2957 46.4099 20.5411C46.5107 20.7865 46.659 21.0097 46.8461 21.1977C47.0334 21.3857 47.2559 21.5348 47.5009 21.6366C47.746 21.7384 48.0086 21.7908 48.2739 21.7908H61.6588V18.6371L46.2588 5.12109Z",
    fill: "#9AF4AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.668 68.5231H11.4939C10.966 68.5231 10.4597 68.3134 10.0864 67.9401C9.71312 67.5667 9.50342 67.0605 9.50342 66.5326V3.99053C9.50342 3.46261 9.71312 2.95631 10.0864 2.58301C10.4597 2.20972 10.966 2 11.4939 2H45.0216L61.6585 18.6369V66.5571C61.6521 67.0808 61.4396 67.5808 61.067 67.9488C60.6943 68.3168 60.1918 68.5231 59.668 68.5231Z",
    stroke: "#00BC66",
    strokeWidth: 2.04787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0215 2V16.6382C45.0237 17.1742 45.2376 17.6875 45.6165 18.0665C45.9955 18.4455 46.5088 18.6594 47.0448 18.6615H61.6584L45.0215 2Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0215 2V16.6382C45.0237 17.1742 45.2376 17.6875 45.6165 18.0665C45.9955 18.4455 46.5088 18.6594 47.0448 18.6615H61.6584L45.0215 2Z",
    stroke: "#00BC66",
    strokeWidth: 2.04787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1999 26.1321H22.9619",
    stroke: "#00BC66",
    strokeWidth: 2.04787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1999 33.5537H22.9619",
    stroke: "#00BC66",
    strokeWidth: 2.04787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1999 40.9673H22.9619",
    stroke: "#00BC66",
    strokeWidth: 2.04787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9826 48.3882H22.9619",
    stroke: "#00BC66",
    strokeWidth: 2.04787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6587 50.5103V52.2796",
    stroke: "#00BC66",
    strokeWidth: 2.04787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7144 68.5229H40.4182",
    stroke: "#00BC66",
    strokeWidth: 2.04787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5771 76.2234H37.2974",
    stroke: "#00BC66",
    strokeWidth: 2.04787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.830e5dd2f6b8fa027aa33047c69b96c6.svg";
export { ForwardRef as ReactComponent };